var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"QuickNews"}},[_c('van-notice-bar',{attrs:{"left-icon":"volume-o","text":"亿师傅安装平台, 0抽佣, 0保证金,即可接单","background":"#fff"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }